import { render, staticRenderFns } from "./GAPop.vue?vue&type=template&id=8dd0aca4&scoped=true&"
import script from "./GAPop.vue?vue&type=script&lang=js&"
export * from "./GAPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd0aca4",
  null
  
)

component.options.__file = "GAPop.vue"
export default component.exports